/*
 * @Descripttion: ''
 * @Author: lilong(lilong@hztianque.com)
 * @Date: 2020-07-16 17:12:36
 * @LastEditTime: 2020-07-16 17:13:57
 */
import moduleRouters from './router'
import modulesStores from './store'

export default (Vue, store, router, http) => { // eslint-disable-line
  router.addRoutes([moduleRouters()])
  store.registerModule('jurisprudenceDaily', modulesStores(http))
}